import React, { useState, useEffect } from "react";
import Headerfile from "../common/Headerfile";
import Footerfile from "../common/Footerfile";
import { getLogisticsRole } from "../../utils/authToken";
import Unauthorized from "../unauthorized/Unauthorized";
import Styles from "./Home.module.css";
import Sidebar from "./Sidebar/Sidebar";

const Home: React.FC = () => {
  const [loggedUserRole, setLoggedUserRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const role = getLogisticsRole();
    setLoggedUserRole(role);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div>
        <div className={Styles.loadingContainer}>
          <div className={Styles.loadingSpinner}></div>
          <div className={Styles.loadingText}>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className={Styles.sidebar}>
      <Headerfile />
      {loggedUserRole == null ? (
        <Unauthorized />
      ) : (
        <div className={Styles.sidebar2}>
          {" "}
          <Sidebar />
        </div>
      )}
      <Footerfile />
    </div>
  );
};

export default Home;
